export default __webpack_public_path__ + "static/media/j45.94f31239.jpg";